import React, { lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import './index.css';
import "./custom.scss"
import "./@core/scss/core.scss"
import "@styles/react/libs/react-select/_react-select.scss";
import "@styles/react/libs/drag-and-drop/drag-and-drop.scss";
import "@styles/react/libs/flatpickr/flatpickr.scss";

import ModalContextProvider from "@context/ModalContext";

const App = lazy(() => import("./App"));

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
    <BrowserRouter>
		<Suspense fallback={null}>
			<ModalContextProvider>
				<App />
			</ModalContextProvider>
		</Suspense>
	</BrowserRouter>
);
